import * as React from "react";
import Image from "../../../components/Image";
export default function NoQuotes() {
    return (React.createElement("div", { className: "grow text-center" },
        React.createElement("div", { className: "flex flex-col items-center border-b border-gray-200 bg-white px-11 py-4" },
            React.createElement(Image, { src: "/assets/icons/magnifying-glass.svg", alt: "Magnifying glass", className: "mb-3" }),
            React.createElement("h4", { className: "mb-0.5 font-bold text-black-100" }, "Sorry, we couldn't find any offers"),
            React.createElement("p", { className: "text-sm text-black-300" }, "We searched our network of insurers and couldn\u2019t find you any offers today. We will continue to monitor our network and reach out when we find a better deal."))));
}
